export default function ListCompleteCheckIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#1DB469" />
      <path
        d="M18.114 9.32358C18.5455 8.89214 19.245 8.89214 19.6764 9.32358C20.1026 9.74973 20.1078 10.4374 19.6921 10.87L13.8114 18.2208C13.803 18.2314 13.7939 18.2415 13.7843 18.2511C13.3528 18.6826 12.6533 18.6826 12.2219 18.2511L8.32358 14.3528C7.89214 13.9214 7.89214 13.2219 8.32358 12.7904C8.75502 12.359 9.45453 12.359 9.88597 12.7904L12.9698 15.8743L18.0847 9.35663C18.0938 9.34504 18.1036 9.334 18.114 9.32358Z"
        fill="white"
      />
      <path
        d="M18.7365 9.96967C19.0255 9.67678 19.4942 9.67678 19.7832 9.96967C20.0687 10.259 20.0722 10.7258 19.7937 11.0195L13.8802 18.0097C13.8746 18.0169 13.8685 18.0238 13.862 18.0303C13.573 18.3232 13.1044 18.3232 12.8153 18.0303L9.21678 14.3839C8.92774 14.091 8.92774 13.6161 9.21678 13.3232C9.50583 13.0303 9.97446 13.0303 10.2635 13.3232L13.3164 16.4167L18.7169 9.9921C18.723 9.98424 18.7295 9.97674 18.7365 9.96967Z"
        fill="white"
      />
    </svg>
  );
}
